import { observer } from "mobx-react";
import { useTranslation } from "@/stores/RootStoreContext";
import { UserPrefs } from "@/stores/userPrefsDomain";
import {
  AnnouncementDTO,
  announcementLevel,
  announcementText,
  dismissAnnouncement,
  showAnnouncement,
} from "./announcementDomain";
import { Alert } from "@/components-v2/Alert";
import { Markdown } from "@/text/Markdown";

export const Announcement = observer(
  ({ userPrefs, announcement }: { userPrefs: UserPrefs; announcement?: AnnouncementDTO }) => {
    const { lang } = useTranslation();
    if (!showAnnouncement(userPrefs, lang, announcement)) {
      return null;
    }
    return (
      <Alert
        type={announcementLevel(announcement)}
        message={
          <Markdown
            value={announcementText(lang, announcement)}
            disableLastMargin
            inheritLinkColor
            enableLinks
          />
        }
        onClose={dismissAnnouncement(announcement)}
      />
    );
  },
);
